<template>
  <div class="col-md-4">
    <div class="card">
      <div class="card-body">
        <div class="card-text">
          <template v-if="serviceProvider">
            <h5>Service Provider</h5>
            <ul class="right-content-list">
              <li v-if="serviceProvider.id">
                <span class="fa fa-fw fa-address-card mr-2" aria-hidden="true" />
                <router-link :to="`/biobank/${serviceProvider.id}`">
                  <span>{{ uiText["view"] }} {{ providerTitle }}</span>
                </router-link>
              </li>
              <li>
                <ViewGenerator :viewmodel="serviceProviderViewmodel" />
              </li>
            </ul>
          </template>

          <template v-if="service.contactInformation">
            <h5>Contact Information</h5>
            <ul class="right-content-list">
              <li>
                <ContactInformation
                  :contactInformation="service.contactInformation"
                />
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { IServices } from "../../interfaces/directory";
import { getServiceProvider } from "../../functions/dataModel";
import { getServiceViewmodel } from "../../functions/serviceViewmodel";
import { useSettingsStore } from "../../stores/settingsStore";
import ViewGenerator from "../generators/ViewGenerator.vue";
import ContactInformation from "./ContactInformation.vue";

const props = defineProps<{
  service: IServices;
}>();

const settingsStore = useSettingsStore();

const uiText = computed(() => settingsStore.uiText);

const serviceProvider = computed(() => getServiceProvider(props.service));

const providerTitle = computed(
  () =>
    serviceProvider.value?.research_infrastructure ||
    serviceProvider.value?.name
);

const serviceProviderViewmodel = computed(() =>
  getServiceViewmodel(
    serviceProvider.value,
    settingsStore.config.serviceProviderReportColumns
  )
);
</script>

<style scoped>
.right-content-list {
  list-style-type: none;
  margin-left: -2.5rem;
}
.right-content-list:not(:last-child) {
  margin-bottom: 1.5rem;
}

.right-content-list li {
  margin-bottom: 0.5rem;
}
</style>